import { StickerTransform } from "./useStickerGestures";

// Drag-to-delete: a circular trash target at the bottom-centre of the canvas.
// Dropping a sticker whose centre lands inside the circle removes it (the
// familiar IG/TikTok gesture). Kept pure so the hit-test is unit-tested.

export const TRASH_ZONE_RADIUS = 56;
export const TRASH_ZONE_BOTTOM_OFFSET = 60;

export function trashZoneCenter(canvasW: number, canvasH: number): { x: number; y: number } {
    return { x: canvasW / 2, y: canvasH - TRASH_ZONE_BOTTOM_OFFSET };
}

export function isOverTrash(t: StickerTransform | null, canvasW: number, canvasH: number): boolean {
    if (!t || canvasW <= 0 || canvasH <= 0) return false;
    const c = trashZoneCenter(canvasW, canvasH);
    return Math.hypot(t.x - c.x, t.y - c.y) <= TRASH_ZONE_RADIUS;
}
